/* CınCık — ürün galerisi üstünde "Önizleme | Ürün fotoğrafı" sekmesi.
   Sayfa her zaman ürün fotoğrafıyla açılır. Müşteri sekmeye dokunursa (ya da masaüstünde yazmaya/fotoğraf seçmeye başlarsa) önizleme açılır.
   Türler: melek (kanatlar), yonca (4 yaprak) ve "üst": ürünün İLK fotoğrafının üstünde, plakaya lazer taramasıyla işlenen isim/fotoğraf.
   Sayfadaki mevcut önizlemelere dokunmaz, onları okur. İlk fotoğraf değişmişse ya da hata olursa sessizce hiçbir şey yapmaz. */
(function () {
  var IC_PV = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l1.9 4.6L18.5 9l-4.6 1.9L12 15.5l-1.9-4.6L5.5 9l4.6-1.4z"/><path d="M19 15l.8 2 2 .8-2 .8-.8 2-.8-2-2-.8 2-.8z"/></svg>';
  var IC_FT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M21 16l-5-5-8 8"/></svg>';
  var CDN = 'https://cdn.shopify.com/s/files/1/0785/7310/9447/files/';
  // Temizlenmiş plaka görselleri (ck-on-<anahtar>.jpg) bu dosyanın yanındaki assets klasöründe
  var ASSET = (document.currentScript && document.currentScript.src) ? document.currentScript.src.replace(/ck-sekme\.js.*$/, '') : '';

  /* Ürün başına: t=tür (foto|isim), f=ilk fotoğraf dosyası, W×h=fotoğraf ölçüsü, q=plakanın 4 köşesi (fotoğraf pikseli),
     w×p=plaka boyu, s=şekil, c=plaka zemini, k=mürekkep, r=döndürme, d=tarama yönü */
  var URUNLER = {"8768435486919":{"t":"foto","f":"product_image_TwHZShYMXd.jpg","W":900,"h":1350,"q":[[315,517],[574,517],[574,773],[315,773]],"w":259,"p":256,"s":"disc","n":"d1","k":"#222","m":"","r":0,"d":"h"},"8736243777735":{"t":"foto","f":"ChatGPTImage13Haz202613_07_44.png","W":900,"h":1373,"q":[[312,525],[578,525],[578,788],[312,788]],"w":266,"p":263,"s":"disc","n":"d2","k":"#222","m":"","r":0,"d":"h"},"8736198656199":{"t":"foto","f":"ChatGPTImage13Haz202612_33_17.png","W":900,"h":1352,"q":[[319,533],[585,533],[585,798],[319,798]],"w":266,"p":265,"s":"disc","n":"d3","k":"#222","m":"","r":0,"d":"h"},"8768435617991":{"t":"foto","f":"product_image_U7mp5Hflwp.jpg","W":900,"h":1350,"q":[[297,762],[570,762],[570,1038],[297,1038]],"w":273,"p":276,"s":"disc","n":"d4","k":"#222","m":"","r":0,"d":"h"},"15412846624967":{"t":"foto","f":"06b-mini-donusum-gold.jpg","W":900,"h":900,"q":[[127,276],[421,276],[421,560],[127,560]],"w":294,"p":284,"s":"heart","n":"kalp","k":"#222","m":"","r":0,"d":"h"},"8768435683527":{"t":"foto","f":"260910_0002_image_edit_5373.png","W":900,"h":900,"q":[[415,407],[464,407],[479,643],[429,651]],"w":50,"p":240,"s":"rect","n":"gozkol","k":"#222","m":"","r":90,"d":"v"},"15373978271943":{"t":"foto","f":"goz-motifli-gumus-bileklik.jpg","W":850,"h":1850,"q":[[291,906],[660,839],[680,937],[306,1009]],"w":378,"p":102,"s":"rect","n":"gozbil","k":"#222","m":"","r":0,"d":"h"},"15380645118151":{"t":"foto","f":"ChatGPTImage30Eyl202614_29_52.png","W":900,"h":900,"q":[[423,514],[500,505],[522,814],[448,826]],"w":76,"p":311,"s":"rect","n":"gozank","k":"#222","m":"","r":90,"d":"v"},"15396900700359":{"t":"foto","f":"2-goz-baskili-cakmak-acik-alev_a05f07c0-4bb7-4285-8397-5fbbf9afac51.jpg","W":900,"h":900,"q":[[387,506],[572,591],[506,743],[318,652]],"w":206,"p":164,"s":"rect","n":"cakmak","k":"#222","m":"","r":0,"d":"h"},"15384331681991":{"t":"isim","f":"4-isimli-bileklik-erkek.jpg","W":900,"h":900,"q":[[283,432],[612,329],[626,382],[300,508]],"w":347,"p":66,"s":"rect","n":"isim","k":"#2b2b2b","m":"","r":0,"d":"h"},"15376882204871":{"t":"isim","f":"ChatGPT_Image_28_Eyl_2026_17_47_29.png","W":900,"h":1376,"q":[[337,668],[581,712],[581,790],[337,744]],"w":248,"p":77,"s":"rect","n":"kunye_g","k":"#fff4d6","m":"n","r":0,"d":"h","alt":{"ChatGPT_Image_28_Eyl_2026_17_44_55.png":{"n":"kunye_s","k":"#f4f4f4","m":"n"}}}};

  function urunId() {
    var i = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
    if (i && i.value) return String(i.value);
    try { return String(window.ShopifyAnalytics.meta.product.id); } catch (e) {}
    return null;
  }

  function mod() {
    var melek = document.querySelector('[data-ck-melek]');
    var yonca = document.querySelector('[data-ck-yonca]');
    if (melek && typeof window.ckMelek === 'function') return { tip: 'melek', el: melek };
    if (yonca && typeof window.ckYonca === 'function') return { tip: 'yonca', el: yonca };
    var id = urunId(), c = id && URUNLER[id];
    if (c) {
      if (c.t === 'foto') {
        var st = document.querySelector('.ck-studio');
        if (st && st.querySelector('canvas') && document.querySelector('[data-ck-file]')) return { tip: 'ust', c: c, st: st };
      } else if (document.querySelector('[data-ck-name-input]')) {
        return { tip: 'ust', c: c };
      }
    }
    return null;
  }

  /* 4 köşe -> matrix3d: w×h birim dikdörtgeni dörtgene oturtur */
  function homog(w, h, q) {
    var s = [[0, 0], [w, 0], [w, h], [0, h]], A = [], b = [], i, c, r, k;
    for (i = 0; i < 4; i++) {
      var x = s[i][0], y = s[i][1], X = q[i][0], Y = q[i][1];
      A.push([x, y, 1, 0, 0, 0, -x * X, -y * X]); b.push(X);
      A.push([0, 0, 0, x, y, 1, -x * Y, -y * Y]); b.push(Y);
    }
    for (c = 0; c < 8; c++) {
      var m = c;
      for (r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[m][c])) m = r;
      var t = A[c]; A[c] = A[m]; A[m] = t; t = b[c]; b[c] = b[m]; b[m] = t;
      for (r = c + 1; r < 8; r++) {
        var f = A[r][c] / A[c][c];
        for (k = c; k < 8; k++) A[r][k] -= f * A[c][k];
        b[r] -= f * b[c];
      }
    }
    var z = [];
    for (i = 7; i >= 0; i--) { var sum = b[i]; for (k = i + 1; k < 8; k++) sum -= A[i][k] * z[k]; z[i] = sum / A[i][i]; }
    return 'matrix3d(' + [z[0], z[3], 0, z[6], z[1], z[4], 0, z[7], 0, 0, 1, 0, z[2], z[5], 0, 1].join(',') + ')';
  }

  function kur(m) {
    var gal = document.querySelector('media-gallery');
    if (!gal || gal.getAttribute('data-ck-sk')) return;
    var tip = m.tip, c = m.c || null, kutular = [], orig = m.st || null, ust = tip === 'ust';

    if (ust && !ASSET) return;
    if (ust) {
      // İlk fotoğraf değişmişse köşe ölçüleri tutmaz: sekmeyi hiç açma
      c.ana = { f: c.f, n: c.n, k: c.k, m: c.m || '' };
      var secimi = function () {
        var g0 = gal.querySelector('.product__media-item img'), src0 = g0 ? (g0.currentSrc || g0.src || '') : '';
        if (src0.indexOf(c.ana.f.replace(/\.[a-z]+$/i, '')) >= 0) return c.ana;
        for (var ad in (c.alt || {})) if (src0.indexOf(ad.replace(/\.[a-z]+$/i, '')) >= 0) { var a1 = c.alt[ad]; return { f: ad, n: a1.n || c.ana.n, k: a1.k || c.ana.k, m: a1.m === undefined ? c.ana.m : a1.m }; }
        return null;
      };
      var sv = secimi();
      if (!sv) return;
      c.f = sv.f; c.n = sv.n; c.k = sv.k; c.m = sv.m;
      if (c.t === 'isim') kutular = [document.querySelector('[data-ck-name-input]')];
    } else {
      var adim = m.el.closest('[data-step="name"]') || document;
      kutular = [].slice.call(adim.querySelectorAll('[data-ck-name-input], [data-ck-name-extra]'));
      if (!kutular.length) return;
    }
    gal.setAttribute('data-ck-sk', '1');

    var ADIMLAR = {
      melek: ['Aşağıdaki <b>İsim</b> kutusuna ismini yaz.', 'Kanatlar açılır, isim kalbin üstünde belirir.', 'Beğendiysen sepete ekle, aynen kazırız.'],
      yonca: ['Aşağıdaki <b>1., 2., 3., 4. İsim</b> kutularına isimleri yaz.', 'Her isim kendi yaprağında belirir.', 'Beğendiysen sepete ekle, aynen kazırız.'],
      foto: ['<b>Fotoğraf seç</b> düğmesine bas ve fotoğrafını yükle.', 'Fotoğrafın ürünün üstüne lazerle işlenir, siyah-beyaz görünür.', 'Kadrajı sayfadaki fotoğraf alanından kaydırıp büyütebilirsin.'],
      isim: ['İsmini <b>yazı kutusuna</b> yaz.', 'İsim ürünün üstüne lazerle işlenir.', 'Beğendiysen sepete ekle, aynen kazırız.']
    }[ust ? c.t : tip];

    var tabs = document.createElement('div');
    tabs.className = 'ck-sk-tabs is-nudge';
    tabs.setAttribute('role', 'tablist');
    tabs.innerHTML =
      '<button type="button" class="ck-sk-tab ck-sk-tab--pv" role="tab" aria-selected="false">' + IC_PV + '<span>Önizleme</span><span class="ck-sk-live">Canlı</span></button>' +
      '<button type="button" class="ck-sk-tab ck-sk-tab--ft" role="tab" aria-selected="true">' + IC_FT + '<span>Ürün fotoğrafı</span></button>';
    var bPv = tabs.children[0], bFt = tabs.children[1];

    var pane = document.createElement('div');
    pane.className = 'ck-sk-pane' + (ust ? ' ck-sk-pane--ust' : '');
    pane.hidden = true;
    var govde;
    if (ust) {
      // Pencere: tüm fotoğraf yerine plakanın çevresi (daha derli, plaka daha büyük)
      var xs = c.q.map(function (n) { return n[0]; }), ys = c.q.map(function (n) { return n[1]; });
      var bx0 = Math.min.apply(0, xs), bx1 = Math.max.apply(0, xs), by0 = Math.min.apply(0, ys), by1 = Math.max.apply(0, ys);
      var bw = bx1 - bx0, bh = by1 - by0, A = bw > bh * 1.8 ? 4 / 3 : 1;
      var ww = Math.min(c.W, Math.max(bw * 1.8, bh * 1.8 * A)), wh = ww / A;
      if (wh > c.h) { wh = c.h; ww = wh * A; }
      var wx = Math.max(0, Math.min(c.W - ww, (bx0 + bx1) / 2 - ww / 2)), wy = Math.max(0, Math.min(c.h - wh, (by0 + by1) / 2 - wh / 2));
      c.win = { x: wx, y: wy, w: ww, h: wh };
      govde = '<div class="ck-sk-stage" style="aspect-ratio:' + ww + '/' + wh + '"><div class="ck-sk-world" style="width:' + c.W + 'px;height:' + c.h + 'px">' +
        '<img class="ck-sk-base" alt="" width="' + c.W + '" height="' + c.h + '" src="' + CDN + c.f + '?width=' + Math.min(2000, c.W * 2) + '">' +
        '<img class="ck-sk-clean" alt="" width="' + c.W + '" height="' + c.h + '" src="' + ASSET + 'ck-on-' + c.n + '.jpg">' +
        '<div class="ck-sk-plate" data-dir="' + c.d + '" data-s="' + c.s + '">' +
        '<div class="ck-sk-rev"><div class="ck-sk-ink">' + (c.t === 'isim' ? '<span class="ck-sk-txt"></span>' : '<canvas class="ck-sk-cv"></canvas>') + '</div></div>' +
        '<span class="ck-sk-laser"></span></div></div><div class="ck-sk-chip"></div></div>' +
        '<div class="ck-sk-bar">' + (c.t === 'isim'
          ? '<input type="text" class="ck-sk-in" autocomplete="off" aria-label="İsim">'
          : '<button type="button" class="ck-sk-up">📷 Fotoğraf seç</button>') + '</div>' +
        (c.t === 'foto' ? '<div class="ck-sk-tools" hidden><button type="button" class="ck-sk-tb" data-z="-1" aria-label="Küçült">−</button>' +
          '<input type="range" class="ck-sk-zm" min="1" max="4" step="0.01" value="1" aria-label="Yakınlaştır">' +
          '<button type="button" class="ck-sk-tb" data-z="1" aria-label="Büyüt">+</button><button type="button" class="ck-sk-rs">Ortala</button></div>' : '') +
        '<div class="ck-sk-atc"><button type="button" class="ck-sk-add">Sepete ekle</button></div>';
    } else {
      govde = '<div class="ck-sk-slot"><div class="' + (tip === 'yonca' ? 'cky' : 'ckm') + '"></div></div>';
    }
    pane.innerHTML = '<button type="button" class="ck-sk-i" aria-label="Önizleme nasıl kullanılır?">i</button>' + govde + '<p class="ck-sk-note"></p>' +
      '<div class="ck-sk-info" role="dialog" aria-label="Önizleme nasıl kullanılır?" hidden><div class="ck-sk-card">' +
      '<button type="button" class="ck-sk-x" aria-label="Kapat">&times;</button>' +
      '<strong>Önizleme nasıl çalışır?</strong>' +
      '<ol>' + ADIMLAR.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ol>' +
      '<small>Görünüm temsilidir; ürün lazerle birebir kazınır.</small>' +
      '<button type="button" class="ck-sk-ok">Anladım</button></div></div>';
    var not = pane.querySelector('.ck-sk-note');
    var bilgi = pane.querySelector('.ck-sk-info');
    var goruldu = false;
    try { goruldu = localStorage.getItem('ck-sk-bilgi') === '1'; } catch (e) {}
    function bilgiAc() { bilgi.hidden = false; }
    function bilgiKapat() { bilgi.hidden = true; try { localStorage.setItem('ck-sk-bilgi', '1'); } catch (e) {} }
    pane.querySelector('.ck-sk-i').addEventListener('click', bilgiAc);
    pane.querySelector('.ck-sk-x').addEventListener('click', bilgiKapat);
    pane.querySelector('.ck-sk-ok').addEventListener('click', bilgiKapat);
    bilgi.addEventListener('click', function (e) { if (e.target === bilgi) bilgiKapat(); });

    gal.parentNode.insertBefore(tabs, gal);
    gal.parentNode.insertBefore(pane, gal.nextSibling);

    var inst = null, guncelle, acik = false, yukseklik = 0, kare = 0;

    if (tip === 'yonca') {
      var sy = pane.querySelector('.ck-sk-slot > div');
      inst = window.ckYonca(sy);
      guncelle = function () {
        kutular.slice(0, 4).forEach(function (k, i) { inst.set(i, k.value); });
        var d = kutular.slice(0, 4).some(function (k) { return k.value.trim(); });
        not.innerHTML = d ? 'Görünüm temsilidir · lazerle birebir kazınır' : '<span class="ck-sk-empty">Her yaprak bir isim. Aşağıya isimleri yaz, burada gör.</span>';
      };
    } else if (tip === 'melek') {
      var sm = pane.querySelector('.ck-sk-slot > div');
      inst = window.ckMelek(sm);
      guncelle = function () {
        inst.set(kutular[0].value);
        not.innerHTML = kutular[0].value.trim() ? 'Görünüm temsilidir · lazerle birebir kazınır' : '<span class="ck-sk-empty">Aşağıya ismini yaz, kanatlar açılıp ismin kalbin üstünde belirsin.</span>';
      };
    } else {
      /* ===== üst: ilk fotoğrafın üstünde lazer önizleme ===== */
      var stage = pane.querySelector('.ck-sk-stage'), world = pane.querySelector('.ck-sk-world');
      var plate = pane.querySelector('.ck-sk-plate'), chip = pane.querySelector('.ck-sk-chip');
      plate.style.width = c.w + 'px'; plate.style.height = c.p + 'px';
      plate.style.transform = homog(c.w, c.p, c.q);
      plate.style.setProperty('--ck-ink', c.k);
      plate.setAttribute('data-blend', c.m || '');
      var baseImg = pane.querySelector('.ck-sk-base');
      function yenileSurum() {
        var sv2 = secimi();
        if (!sv2 || sv2.f === c.f) return;
        c.f = sv2.f; c.n = sv2.n; c.k = sv2.k; c.m = sv2.m;
        baseImg.src = CDN + c.f + '?width=' + Math.min(2000, c.W * 2);
        pane.querySelector('.ck-sk-clean').src = ASSET + 'ck-on-' + c.n + '.jpg';
        plate.style.setProperty('--ck-ink', c.k);
        plate.setAttribute('data-blend', c.m || '');
      }
      var ink = pane.querySelector('.ck-sk-ink');
      function olc() {
        var k = stage.clientWidth / c.win.w;
        if (k > 0) world.style.transform = 'translate(' + (-c.win.x * k) + 'px,' + (-c.win.y * k) + 'px) scale(' + k + ')';
      }
      window.addEventListener('resize', olc);
      function tara() { plate.classList.remove('is-sweep'); void plate.offsetWidth; plate.classList.add('is-sweep'); }
      var eskiDolu = false, yeni = false;
      function acildi(d) {
        plate.classList.toggle('is-on', d); world.classList.toggle('is-on', d);
        chip.style.display = d ? 'none' : '';
        if (d && (!eskiDolu || yeni)) { tara(); yeni = false; }
        eskiDolu = d;
      }

      if (c.t === 'isim') {
        var tx = pane.querySelector('.ck-sk-txt'), pin = pane.querySelector('.ck-sk-in'), fk = kutular[0], flashT = 0;
        pin.maxLength = fk.maxLength > 0 ? fk.maxLength : 20;
        pin.placeholder = fk.placeholder || 'İsmini yaz';
        chip.textContent = 'İsmini yaz, plakaya işlensin';
        function boyut() {
          var fs = c.p * 0.72; tx.style.fontSize = fs + 'px';
          var w = tx.scrollWidth, max = c.w * 0.86;
          if (w > max) tx.style.fontSize = (fs * max / w) + 'px';
        }
        guncelle = function () {
          var v = fk.value.trim();
          if (pin.value !== fk.value) pin.value = fk.value;
          tx.textContent = v; boyut();
          acildi(!!v);
          not.innerHTML = v ? 'Görünüm temsilidir · lazerle birebir kazınır' : '<span class="ck-sk-empty">İsmini yaz, plakada belirsin.</span>';
          plate.classList.remove('is-flash'); void plate.offsetWidth; plate.classList.add('is-flash');
        };
        pin.addEventListener('input', function () {
          fk.value = pin.value;
          fk.dispatchEvent(new Event('input', { bubbles: true }));
          fk.dispatchEvent(new Event('change', { bubbles: true }));
        });
      } else {
        var cvK = pane.querySelector('.ck-sk-cv'), kx = cvK.getContext('2d'), cvO = orig.querySelector('canvas');
        var S = 2;
        function olcekle() {
          var k = stage.clientWidth / c.win.w, dpr = window.devicePixelRatio || 1;
          S = Math.max(1, Math.min(3, (k > 0 ? k : 1) * dpr * 1.1));
          var nw = Math.round(c.w * S), nh = Math.round(c.p * S);
          if (cvK.width !== nw || cvK.height !== nh) { cvK.width = nw; cvK.height = nh; }
        }
        olcekle();
        var tmp = document.createElement('canvas');
        var up = pane.querySelector('.ck-sk-up');
        chip.textContent = 'Fotoğrafını seç, plakaya işlensin';
        up.addEventListener('click', function () { var f = document.querySelector('[data-ck-file]'); if (f) f.click(); });
        var sonT = 0, sonSample = true, sonDusuk = false;
        function ciz() {
          try {
            olcekle();
            var W = cvK.width, H = cvK.height;
            if (!cvO.width || !cvO.height) return;
            // kaynak: tam çözünürlükte, formdaki kadrajla birebir aynı (küçük kadraj tuvali büyütülmez)
            var kaynak = cvO, ar = cvO.width / cvO.height, ap = orig.ckApi;
            if (ap && ap.render) {
              var uzun = Math.min(2400, Math.round(Math.max(W, H) * 1.25)), tw = ar >= 1 ? uzun : Math.round(uzun * ar), th = ar >= 1 ? Math.round(uzun / ar) : uzun;
              if (tmp.width !== tw || tmp.height !== th) { tmp.width = tw; tmp.height = th; }
              if (ap.render(tmp.getContext('2d'), tw, th)) kaynak = tmp;
            }
            kx.clearRect(0, 0, W, H);
            kx.imageSmoothingQuality = 'high';
            kx.save(); kx.translate(W / 2, H / 2); kx.rotate((c.r || 0) * Math.PI / 180);
            var dw = c.r ? H : W, dh = c.r ? W : H, ir = kaynak.width / kaynak.height, rr = dw / dh, sw, sh;
            if (ir > rr) { sh = dh; sw = dh * ir; } else { sw = dw; sh = dw / ir; }
            kx.drawImage(kaynak, -sw / 2, -sh / 2, sw, sh); kx.restore();
          } catch (e) {}
        }
        function dongu(t) {
          if (!acik) { kare = 0; return; }
          if (t - sonT > 60) {
            sonT = t;
            var sample = orig.classList.contains('is-sample');
            if (!sample) ciz();
            if (c.araclar) c.araclar();
            var dk = !sample && orig.ckApi && orig.ckApi.lowRes && orig.ckApi.lowRes();
            if (dk !== sonDusuk) { sonDusuk = dk; guncelle(); }
            if (sample !== sonSample || (!sample && !eskiDolu)) { sonSample = sample; acildi(!sample); guncelle(); }
          }
          kare = requestAnimationFrame(dongu);
        }
        inst = { basla: function () { if (!kare) kare = requestAnimationFrame(dongu); } };
        guncelle = function () {
          var sample = orig.classList.contains('is-sample');
          if (!sample) ciz();
          acildi(!sample);
          var dusuk = !sample && orig.ckApi && orig.ckApi.lowRes && orig.ckApi.lowRes();
          not.innerHTML = sample ? '<span class="ck-sk-empty">Fotoğrafını yükle, ürünün üstünde gör.</span>'
            : dusuk ? '<span class="ck-sk-empty ck-sk-warn">Bu fotoğrafın çözünürlüğü düşük, baskıda net çıkmayabilir. Daha net bir fotoğraf yüklemeni öneririz.</span>'
            : 'Kadrajı sayfadaki alandan ayarlayabilirsin · görünüm temsilidir';
        };
        var fi = document.querySelector('[data-ck-file]');
        if (fi) fi.addEventListener('change', function () { yeni = true; setTimeout(function () { if (acik) guncelle(); }, 450); });

        /* Hizalama: sürükle, iki parmakla büyüt, tekerlek, çubuk. Sayfadaki kadraj aracına bağlanır (aynı kadraj siparişe gider). */
        var api = function () { return orig.ckApi || null; };
        var araclar = pane.querySelector('.ck-sk-tools'), zm = pane.querySelector('.ck-sk-zm');
        var ptr = {}, son = null, pinch = 0;
        plate.addEventListener('pointerdown', function (e) {
          if (!api() || orig.classList.contains('is-sample')) return;
          try { plate.setPointerCapture(e.pointerId); } catch (x) {}
          ptr[e.pointerId] = { x: e.clientX, y: e.clientY }; son = { x: e.clientX, y: e.clientY }; plate.classList.add('is-drag');
        });
        plate.addEventListener('pointermove', function (e) {
          if (!ptr[e.pointerId] || !api()) return;
          ptr[e.pointerId] = { x: e.clientX, y: e.clientY };
          var ids = Object.keys(ptr);
          if (ids.length === 2) {
            var a1 = ptr[ids[0]], b1 = ptr[ids[1]], d = Math.hypot(a1.x - b1.x, a1.y - b1.y);
            if (pinch) api().zoomBy(d / pinch);
            pinch = d; return;
          }
          if (!son) return;
          var r = plate.getBoundingClientRect(), dx = (e.clientX - son.x) / r.width, dy = (e.clientY - son.y) / r.height;
          son = { x: e.clientX, y: e.clientY };
          if (c.r) api().pan(dy, -dx); else api().pan(dx, dy);
        });
        function birak(e) {
          delete ptr[e.pointerId]; pinch = 0;
          var ids = Object.keys(ptr); son = ids.length ? ptr[ids[0]] : null;
          if (!ids.length) plate.classList.remove('is-drag');
        }
        plate.addEventListener('pointerup', birak); plate.addEventListener('pointercancel', birak);
        plate.addEventListener('wheel', function (e) {
          if (!api() || orig.classList.contains('is-sample')) return;
          e.preventDefault(); api().zoomBy(e.deltaY < 0 ? 1.08 : 1 / 1.08);
        }, { passive: false });
        zm.addEventListener('input', function () { if (api()) api().setZ(parseFloat(zm.value)); });
        [].forEach.call(pane.querySelectorAll('.ck-sk-tb'), function (b) {
          b.addEventListener('click', function () { if (api()) api().zoomBy(b.getAttribute('data-z') === '1' ? 1.2 : 1 / 1.2); });
        });
        pane.querySelector('.ck-sk-rs').addEventListener('click', function () { if (api()) api().reset(); });
        // araç çubuğu: yalnız gerçek fotoğraf varken görünür, çubuk değeri sayfadakiyle eşit tutulur
        c.araclar = function () {
          var sample = orig.classList.contains('is-sample');
          araclar.hidden = sample;
          if (!sample && api() && document.activeElement !== zm) zm.value = api().getZ();
        };
      }
    }

    var ekle = pane.querySelector('.ck-sk-add');
    if (ekle) {
      ekle.addEventListener('click', function () {
        var o = document.querySelector('form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] .product-form__submit');
        if (!o) return;
        o.click();
        // eksik bilgi varsa (fotoğraf, isim...) sayfadaki uyarıya götür
        setTimeout(function () {
          var er = document.querySelector('.ck-err:not([hidden])');
          if (er && er.textContent.trim()) {
            not.innerHTML = '<span class="ck-sk-empty">Eksik bilgi var: aşağıdaki formda işaretlendi.</span>';
            try { er.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
          }
        }, 350);
      });
    }

    var ziyaret = false;
    function sec(pv, elle) {
      acik = pv;
      bPv.setAttribute('aria-selected', pv ? 'true' : 'false');
      bFt.setAttribute('aria-selected', pv ? 'false' : 'true');
      if (pv) {
        if (!ust && gal.offsetHeight > 0) yukseklik = gal.offsetHeight;
        if (!ust) pane.style.minHeight = yukseklik ? yukseklik + 'px' : '';
        gal.style.display = 'none';
        pane.hidden = false;
        if (ust) { yenileSurum(); olc(); }
        if (inst && inst.basla) inst.basla();
        guncelle();
      } else {
        pane.hidden = true;
        gal.style.display = '';
      }
      if (pv && elle !== false) { ziyaret = true; tabs.classList.remove('is-nudge'); }
    }
    bPv.addEventListener('click', function () { sec(true); if (!goruldu) { goruldu = true; bilgiAc(); } });
    bFt.addEventListener('click', function () { sec(false); });

    var genis = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: false };
    function etkinlik() {
      if (!bilgi.hidden) bilgiKapat();
      goruldu = true;
      guncelle();
      if (!ziyaret && genis.matches) sec(true, false);
      if (!ziyaret) { ziyaret = true; tabs.classList.remove('is-nudge'); }
    }
    if (ust && c.t === 'foto') {
      var f2 = document.querySelector('[data-ck-file]');
      if (f2) f2.addEventListener('change', etkinlik);
    } else {
      kutular.forEach(function (k) { k.addEventListener('input', etkinlik); });
    }
    if (!ust || c.t === 'isim') guncelle();
  }

  function basla() {
    try {
      var m = mod();
      if (m) return kur(m);
      // stüdyo gibi parçalar sayfa kurulumundan sonra eklenebilir: kısa süre bekle
      var bitti = false;
      var mo = new MutationObserver(function () {
        var x = mod();
        if (x && !bitti) { bitti = true; mo.disconnect(); try { kur(x); } catch (e) {} }
      });
      mo.observe(document.body, { childList: true, subtree: true });
      setTimeout(function () { if (!bitti) { bitti = true; mo.disconnect(); } }, 8000);
    } catch (e) { /* sessiz */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', basla); else basla();
})();
